module.exports = __webpack_public_path__ + "img/learn_balloon3_sp.49bc5b7b.svg";